var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:({color: _vm.color})},[(_vm.showTime)?[_vm._t("default"),_c('span',[_vm._v(_vm._s(_vm.dataTime))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }